import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_EMAIL_HOTALERT_UPDATE:
      return action.listsEmailHotAlert
    // return UpdateObjectHelpers(state, { listsUser: action.listsUser });
    default:
      return state
  }
}

